import type * as React from "react";
import type { Ionicons } from "@expo/vector-icons";

export type CalloutId = "invite_friends";
export type CalloutPlacement = "events_list" | "profile";

type CalloutConfig = {
  icon: React.ComponentProps<typeof Ionicons>["name"];
  title: string;
  /** Static description. Omit when the callout's component computes its own. */
  description?: string;
  ctaLabel: string;
  href: string;
};

/**
 * Copy and destination for each callout. Adding a callout is a change here plus
 * a small component that wires it to `useCallout`.
 */
export const CALLOUTS: Record<CalloutId, CalloutConfig> = {
  invite_friends: {
    icon: "heart-outline",
    title: "Convide suas amigas para o LEZZ",
    // Description depends on the number of invites left, so InviteCallout
    // computes it itself instead of using a static value here.
    ctaLabel: "Convidar amigas",
    href: "/user/invites",
  },
};
